import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2604/logo.png';
import Title from '../img/event/2604/title.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202604 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FCF1E6]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col gap-10 pt-14 sm:gap-20 sm:pt-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 젭스 영어교실 로고 */}
            <div className="mx-auto flex max-w-[100px] sm:max-w-[130px] md:max-w-[160px]">
              <img src={Logo} alt="젭스 영어교실 로고" />
            </div>

            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex flex-col">
                <img
                  src={Title}
                  alt="작심상일 NO!, 작심4월 YES! GOD生 갓생 시작하기! APRIL"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#F25952]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 말풍선 섹션 */}
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 타이틀 문구 */}
            <div className="text-center text-xl font-bold text-white sm:text-2xl">
              4월 프로모션 혜택
            </div>

            {/* 말풍선 1 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FCF1E6] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-sm font-medium text-[#F25952] sm:text-lg">
                <span className="font-bold">우리 아이의 갓생,</span> 4월부터
                시작!
                <br />
                가정에서 신앙과 영어를 동시에 키우고 싶다면?
              </p>
            </div>
            {/* 말풍선 2 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FEF89C] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-sm font-medium text-[#F25952] sm:text-lg">
                <span className="font-bold">부모의 갓생,</span> 아이에게 물려줄
                최고의 유산!
                <br />
                말씀으로 아이의 비전을 확장시켜주고 싶다면?
              </p>
            </div>
            {/* 말풍선 3 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FCF1E6] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-sm font-medium text-[#F25952] sm:text-lg">
                <span className="font-bold">다음 세대의 갓생,</span> 젭스와 함께
                만들어가요!
                <br />
                교육의 본질을 놓치고 싶지 않다면?
              </p>
            </div>
          </section>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 섹션 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-base font-semibold text-[#FEF89C] sm:text-2xl">
                신앙과 영어로 활짝 꽃피워줄
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-xl font-extrabold text-white sm:text-3xl">
                4월 온라인 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center bg-[#FDF4B4]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 타이틀 */}
            <p className="text-center text-xl font-extrabold text-[#303048] sm:text-4xl">
              우리 아이의 잠재력을
              <br />
              폭발시킬 절호의 기회!
            </p>
            {/* 박스 */}
            <section className="flex w-full flex-col gap-5 sm:gap-8">
              <div className="grid auto-rows-fr grid-cols-1 gap-5">
                <TextBox className="h-full">
                  <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                    성경적 가치관을 바탕으로
                    <br />
                    <span className="text-black">인성과 지성을 동시에 UP!</span>
                  </p>
                </TextBox>
                <TextBox className="h-full">
                  <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                    합리적인 교육비
                    <span className="text-black">로 최상의 교육 체험!</span>
                  </p>
                </TextBox>
                <TextBox className="h-full">
                  <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                    젭스만의 특허 교수법으로
                    <br />
                    <span className="text-black">
                      외우지 않아도 영어가 입에서 술술~
                    </span>
                  </p>
                </TextBox>
              </div>
            </section>
          </div>

          {/* 타이틀 */}
          <p className="text-center text-lg font-bold text-black sm:text-xl md:text-2xl">
            영어를 넘어 복음의 도구로,
            <br />
            지식을 넘어 지혜의 리더로!
            <br />
            <br />
            4월에 심은 젭스라는 씨앗이
            <br />
            훗날 세상을 변화시킬
            <br />
            거대한 나무가 될 것입니다.
            <br />
            <br />
            <span className="bg-[#F25952] text-[#FDF4B4]">
              &nbsp;&nbsp;그 위대한 여정에 여러분을 초대합니다!&nbsp;&nbsp;
            </span>
          </p>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-lg font-bold sm:p-5 sm:text-2xl md:text-4xl">
              4월 젭스영어교실&nbsp;
              <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202604;
